module.exports = __webpack_public_path__ + "static/media/img-placeholder.318f26a9.png";